import { useRef, useState } from 'react';
//import { useAuth } from '../hooks/useAuth';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../hooks/useRootStore';
import { Box, Button, TextField } from '@mui/material';
import { match } from 'ts-pattern';

const ResetPassword = observer(() => {

    const { api } = useRootStore();
    const [userLogin, setUserLogin] = useState(document.getElementById('login')?.nodeValue ?? '');
    const [success, setSuccess] = useState<boolean | undefined>(undefined);
    const valueRef = useRef()

    const handleRequest = () => {
        setSuccess(undefined);
        api
            .requestResetPassword(userLogin)
            .then(response => setSuccess(response));
    };

    return (
        <Box sx={{ paddingTop: "50px" }} >
            <Box sx={{ paddingTop: "15px" }}>
                <TextField
                    className="white"
                    id="login"
                    label="Логин"
                    variant="outlined"
                    required
                    inputRef={valueRef}
                    onChange={(e) => setUserLogin(e.target.value)}
                />
            </Box>
            <Box sx={{ paddingTop: "15px" }}>
                <Button onClick={handleRequest}>Сбросить пароль</Button>
            </Box>
            <Box sx={{ padding: "15px" }}>
                {
                    match(success)
                        .with(true, () => 'Ссылка для сброса пароля отправлена на почту')
                        .with(false, () => 'Ошибка сброса пароля')
                        .otherwise(() => '')
                }
            </Box>
        </Box>
    );
});

export default ResetPassword;